<template>
  <div id="OrganizationSelectModal">
    <div class="modal-card" style="width:900px;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">{{title}}</p>
      </header>
      <section class="modal-card-body">
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>医療機関名</th><td><input type="text" v-model="orgName" maxlength="256"/></td>
              <th>都道府県</th>
              <td>
                <select v-model="prefecture" name="都道府県" >
                <option value=""/><option value="北海道">北海道</option><option value="青森県">青森県</option><option value="岩手県">岩手県</option><option value="宮城県">宮城県</option><option value="秋田県">秋田県</option><option value="山形県">山形県</option><option value="福島県">福島県</option><option value="茨城県">茨城県</option><option value="栃木県">栃木県</option><option value="群馬県">群馬県</option><option value="埼玉県">埼玉県</option><option value="千葉県">千葉県</option><option value="東京都">東京都</option><option value="神奈川県">神奈川県</option><option value="新潟県">新潟県</option><option value="富山県">富山県</option><option value="石川県">石川県</option><option value="福井県">福井県</option><option value="山梨県">山梨県</option><option value="長野県">長野県</option><option value="岐阜県">岐阜県</option><option value="静岡県">静岡県</option><option value="愛知県">愛知県</option><option value="三重県">三重県</option><option value="滋賀県">滋賀県</option><option value="京都府">京都府</option><option value="大阪府">大阪府</option><option value="兵庫県">兵庫県</option><option value="奈良県">奈良県</option><option value="和歌山県">和歌山県</option><option value="鳥取県">鳥取県</option><option value="島根県">島根県</option><option value="岡山県">岡山県</option><option value="広島県">広島県</option><option value="山口県">山口県</option><option value="徳島県">徳島県</option><option value="香川県">香川県</option><option value="愛媛県">愛媛県</option><option value="高知県">高知県</option><option value="福岡県">福岡県</option><option value="佐賀県">佐賀県</option><option value="長崎県">長崎県</option><option value="熊本県">熊本県</option><option value="大分県">大分県</option><option value="宮崎県">宮崎県</option><option value="鹿児島県">鹿児島県</option><option value="沖縄県">沖縄県</option>
                </select>
              </td>
              <th>住所</th><td><input type="text" v-model="address" maxlength="10"/></td>
            </tr>
            <template v-if="canSelect">
              <tr>
                <th>種別</th>
                <td>
                </td>
              </tr>
            </template>
          </table>
          <div class="searchButton-area" style="margin-bottom:10px;text-align: center;">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area">
          <b-table
            v-if="data.length > 0"
            id="facilitySelectTable"
            :data="data"
            paginated
            per-page="20"
            pagination-position="both"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="customerId" label="" width="5" centered>
                <b-radio class="customRadio" name="radioItem" v-model="selectedItem" :native-value="props.row"></b-radio>
              </b-table-column>
              <b-table-column field="orgName" label="医療機関名" width="80">{{props.row.orgName}}</b-table-column>
              <b-table-column field="address" label="住所" width="100" >{{props.row.prefecture}}{{props.row.city}}{{props.row.address}}{{props.row.building}}</b-table-column>
              <b-table-column field="phone" label="連絡先" width="40" >{{props.row.phoneNumber}}</b-table-column>
              <template v-if="displayMail">
                <b-table-column field="mail" label="メールアドレス" width="70" >{{props.row.mail}}</b-table-column>
              </template>
            </template>
          </b-table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="save" :disabled="!selectedItem">決定</button>
        <button class="button" type="button" @click="$parent.close()">閉じる</button>
      </footer>
    </div>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";
import {extUserStatus} from "@/components/mock/base/const.js";
export default {
  name: "OrganizationSelectModal",
  props:{
    title: {default: "医療機関選択"},
    serviceId: {default: ""},
    agreedInfoDisclosure:false,
    exclusionId:null,
    displayMail:{default: true},
  },
  methods: {
    save: function() {
      this.$emit('select', this.selectedItem);
      this.$parent.close();
    },
    doSearch: function() {
      let _this = this;
      
      // Web Api Call
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getOrganizationListPOST({
            body:{
              orgName:_this.orgName,
              prefecture:_this.prefecture,
              address:_this.address,
              roleList:[_this.role.role_hospital],
              status: _this.extUserStatus.registed,
              agreedInfoDisclosure:true,
              serviceId: _this.serviceId,
              agreedInfoDisclosure:_this.agreedInfoDisclosure
            }
          });
        },
        function(result) {
          // 検索結果取得
          _this.data = result.obj
          if(_this.exclusionId){
            // 検索結果から除外対象を除く
            _this.data = _this.data.filter(val => val.id != _this.exclusionId)
          }
        },
        function(result) {
          // エラーメッセージ表示
          _this.showErrorMessage(result);
        },
      );
    },
  },
  data() {
    return {
      role: role,
      extUserStatus: extUserStatus,
      data: [],
      orgId: "",
      customerCode:"",
      orgName:"",
      prefecture:"",
      address:"",
      selectedRole:"",
      selectedItem:'',
    };
  },
  filters: {},
  components: {},
  mounted: function () {},
};
</script>
<style lang="scss" scoped>
.customRadio {
  width:10px;
}
.result-area {
  height: 450px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/OrganizationSelectModal.vue